import React from 'react'
import { useTranslation } from 'react-i18next'
import { isHour, phoneRegex } from './kegCollectionFormUtils'

function useKegCollectionErrorState(formValues, validateCustomerName = false) {
  const [validationErrors, setValidationErrors] = React.useState({})
  const { t: translate } = useTranslation()

  React.useEffect(() => {
    const next = {}
    const { startHour, endHour, availableDays, phoneNumber, kcRequestItemQtyObjectSet } = formValues
    if (validateCustomerName) {
      const customerName = formValues?.customerName || ''
      if (!customerName || customerName.trim().length === 0) {
        next.customerName = translate('kegCollectionFormVenueSearch')
      } else if (customerName.length <= 2) {
        next.customerName = translate('kegCollectionFormVenueNameTooShort')
      } else if (customerName.length > 100) {
        next.customerName = translate('kegCollectionFormVenueNameTooLong')
      }
    }
    if (!isHour(startHour)) next.startHour = translate('kegCollectionFormInvalidStartTime')
    if (!isHour(endHour)) next.endHour = translate('kegCollectionFormInvalidEndTime')
    if (isHour(startHour) && isHour(endHour) && endHour <= startHour) {
      next.endHour = translate('kegCollectionFormEndHourMustBeAfterStartHour')
    }

    const noneChecked = Object.values(availableDays || {}).every(v => !v)
    if (noneChecked) next.availableDays = translate('kegCollectionFormSelectAtLeastOneWeekday')

    if (phoneNumber) {
      if (!phoneRegex.test(phoneNumber)) {
        next.phoneNumber = translate('kegCollectionFormPhoneAcceptedChars')
      }
    }

    const totalKegs = kcRequestItemQtyObjectSet.reduce(
      (acc, kegCount) => acc + (isNaN(kegCount.quantity) ? 0 : kegCount.quantity),
      0
    )
    if (totalKegs === 0) {
      next.kcRequestItemQtyObjectSet = translate('kegCollectionFormCollectionQty')
    }

    setValidationErrors(next)
  }, [formValues, validateCustomerName, translate])

  return { validationErrors }
}

export default useKegCollectionErrorState
